import { render } from "./GastoPlanificadoForm.vue?vue&type=template&id=27572eba&scoped=true"
import script from "./GastoPlanificadoForm.vue?vue&type=script&lang=js"
export * from "./GastoPlanificadoForm.vue?vue&type=script&lang=js"

import "./GastoPlanificadoForm.vue?vue&type=style&index=0&id=27572eba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27572eba"]])

export default __exports__